function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import Box from './Box';
import DescriptionGridDescription from './DescriptionGridDescription';
import DescriptionGridTerm from './DescriptionGridTerm';
const DescriptionGridCell = /*#__PURE__*/React.memo(_ref => {
  let {
    children,
    description,
    term,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, _extends({
    __css: {
      py: 3,
      px: 3,
      borderBottom: 'default',
      display: 'block',
      flex: '1 1 0'
    }
  }, props), !!term && /*#__PURE__*/React.createElement(DescriptionGridTerm, null, term), !!description && /*#__PURE__*/React.createElement(DescriptionGridDescription, null, description), children);
});
DescriptionGridCell.propTypes = {};
DescriptionGridCell.defaultProps = {};
DescriptionGridCell.displayName = 'DescriptionGridCell';
export default DescriptionGridCell;